import instance from './instance';
export const findAll = (businessType) => {
    return instance.get(`/home`, {
        params: { businessType },
    })
        .then(response => ({ response }))
        .catch(error => ({ error }));
};
